import React from "react";
import BlurredOverlay from "./BlurredOverlay";
import { Icon } from "@showitinc/showit-wc";
import styles from "./MediaLoadingOverlay.module.css";

/**
 * Full-screen translucent overlay that shows a centered spinner and message.
 * Displays during media upload operations with an animated icon and loading message.
 *
 * @component
 * @param {Object} props - Component props
 * @param {boolean} [props.show=false] - Whether to show the overlay (passed to BlurredOverlay)
 * @param {string} [props.message="Adding image to media library"] - Loading message to display
 * @returns {JSX.Element} Media loading overlay component
 *
 * @example
 * // Basic usage
 * <MediaLoadingOverlay show={true} />
 *
 * @example
 * // With custom message
 * <MediaLoadingOverlay
 *   show={isUploading}
 *   message="Processing your image..."
 * />
 */
const MediaLoadingOverlay = ({ show = false, message = "Adding image to media library" }) => {
  return (
    <BlurredOverlay
      data-testid="media-loading-overlay"
      show={show}
      styleOverride={{ height: "100vh", position: "fixed", inset: 0, zIndex: 1000 }}
    >
      <div className={styles.overlay}>
        <div className={styles.icon}>
          <Icon type="mediaLibrary" size="20" />
        </div>
        <div className={styles.message}>
          <span>{message}</span>
          <span className={styles.dots} />
        </div>
      </div>
    </BlurredOverlay>
  );
};

export default MediaLoadingOverlay;
